import { inject, Injectable } from '@angular/core';

import { DialogService } from '@hglobal/common';

import { CoursesReportComponent } from './courses-report.component';

export interface CoursesReportDialogData {
  userId: number;
}

@Injectable()
export class CoursesReportDialog {
  readonly #dialogService = inject(DialogService);

  open(userId: number): void {
    this.#dialogService.open(CoursesReportComponent, { userId });
  }
}
